import {Injectable, Component} from '@angular/core';
import { HttpClientModule, HttpClientJsonpModule, HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/operator/timeout';
import { Observable } from 'rxjs/Observable';
import { HTTP } from '@ionic-native/http/ngx';
import { CapacitorHttp, HttpResponse, HttpOptions } from '@capacitor/core';



@Injectable({
  providedIn: 'root'
})

export class Connection {


    private baseUrl: any;
    private response: any;

    constructor(public http: HttpClient, public httpNative: HTTP) {

    }

    setBaseUrl(baseUrl) {
      this.baseUrl = baseUrl;
    }

    generateRequestUrl(target) {
  		var reqUrl = this.baseUrl+target;
  		var reqTargetSplit = target.match('://');
  		if (reqTargetSplit && reqTargetSplit.length>0){ reqUrl = target; }
  		//console.log("Generated: "+reqUrl);
      //alert("Generated: "+reqUrl);

  		return reqUrl;
    }

    /*requestJsonpGet(target, httpParams, successFn, errorFn, component) {

      //const httpParams = new HttpParams();
      //httpParams.set('query', JSON.stringify(params));

      //let httpParams = JSON.stringify(params);
      //alert(params.getAll());
      var paramString = httpParams.toString();
      //alert(paramString);
      var urlTarget = this.generateRequestUrl(target);

      const url = '${urlTarget}?${paramString}';
      this.http.jsonp(url, 'JSON_CALLBACK').timeout(60000).subscribe(
        data => { successFn(data, component)},
        err => {errorFn(err, component)},
        () => {}
      );
    }*/

    requestHttpGet(target, httpParams, successFn, errorFn, component) {
      const options = {
        params: httpParams
      }
      this.http.get(this.generateRequestUrl(target), options).timeout(60000).subscribe(
        data => { successFn(data, component)},
        err => {errorFn(err, component)},
        () => {}
      );
    }

    async requestHttpGetNative(target, httpParams, successFn, errorFn, component) {

      try {

        const response = await this.httpNative.get(target, httpParams, {});

        successFn(response, component);

      } catch (error) {

        errorFn(error, component);
      }

      /*this.httpNative.get(target,
        httpParams,
        { Authorization: 'OAuth2: token' }).then(
          data => { successFn(data, component)},
          error => { errorFn(error, component)}
        );*/
    }

    async requestHttpPostNative(target, httpParams, successFn, errorFn, component) {

      try {
        //this.httpNative.setHeader('*', String("Content-Type"), String("application/json"));
        this.httpNative.setDataSerializer("json");

        const response = await this.httpNative.post(target, httpParams, {'Content-Type':'application/json'});

        successFn(response, component);

      } catch (error) {

        errorFn(error, component);
      }

      /*this.httpNative.get(target,
        httpParams,
        { Authorization: 'OAuth2: token' }).then(
          data => { successFn(data, component)},
          error => { errorFn(error, component)}
        );*/
    }


    requestHttpPost(target, params, successFn, errorFn, component) {
      let headers = new HttpHeaders({'Content-Type':'application/json'});
      const options = {
        headers: headers,
        responseType: 'json' as const,
        withCredentials: false
      };

      this.http.post(this.generateRequestUrl(target), JSON.stringify(params), options).timeout(60000).subscribe(
        response => {successFn(response, component)},
        error => {errorFn(error, component)},
        () => {}
      );
    }

    async requestHttpPostCapacitor(target, params, successFn, errorFn, component) {

      try {
        const options = {
          url: target,
          headers: {'Content-Type':'application/json'},
          data: params,
        };

        const response = await CapacitorHttp.post(options);
        response.data = JSON.stringify(response.data);

        successFn(response, component);

      } catch (error) {
        errorFn(error, component);
      }



      // or...
       //const response = await CapacitorHttp.request({ options, method: 'POST' })
    };

    async requestHttpGetCapacitor(target, params, successFn, errorFn, component) {

      try {
        const options = {
          url: target,
          headers: {'Content-Type':'application/json'},
          params: params,
        };

        const response = await CapacitorHttp.get(options);
        response.data = JSON.stringify(response.data);

        successFn(response, component);

      } catch (error) {
        errorFn(error, component);
      }



      // or...
       //const response = await CapacitorHttp.request({ options, method: 'POST' })
    };

}
